export default "__VITE_ASSET__0b5a71a5__"